/*global  BMap*/

import { observable, computed, autorun, action, reaction } from 'mobx';

import { getStreetDetail } from "@services/http";
import { myConst, myFn, myMap } from "@config/";
import { makeMarkerHtml } from "@/utils/utils";
import {
    DATA_TYPE_STREET,
    DATA_TYPE_PARKING,
    DATA_TYPE_OIL,
    DATA_TYPE_NEWENERGY,
    DATA_TYPE_WC,
} from "@utils/dataType";
const { $$ } = myFn;

export default class MapState {
    constructor(rootStore) {
        this.rootStore = rootStore;

        reaction(() => this.mapPageStateIsOk, (mapPageStateIsOk) => {
            console.log('mapPageStateIsOk', mapPageStateIsOk);
            if (mapPageStateIsOk) {
                myFn.init();
                this.rootStore.appStore.firstPageIsOk(); // 必须放下面 可以让 init 知道是不是第一次进来 这样可以省掉第一次进来时候清理地图
            }
        }, { name: 'mapPageIsOk' });
    }

    @observable
    mapPageState = {
        ajax: false,
        mapOk: false,
        hideMarkerText: false,
    }

    win = {
        infoBox: '',// map initMap 赋值为 InfoBox 类
        // openMarkerId: -1,// openMarkerId -> 当前 marker id 自己挂到对象上
        // _isOpen: false, // _isOpen -> 是否打开  infoBox自有属性
    }

    defaultLoc = {
        lat: 27.833725,
        lng: 113.1404,
        accuracy: 100,
        bLoc: '', // map initMap 地图初始化后根据 lat lng 生成并赋值
    }
    myLoc = {
        lat: 27.833725,
        lng: 113.1404,
        accuracy: 100,
        bLoc: "",// map initMap 地图初始化后根据 lat lng 生成并赋值
        address: "",
    }
    centerLoc = {
        lat: 27.833725,
        lng: 113.1404,
    }

    @computed get mapPageStateIsOk() {
        return this.mapPageState.mapOk && this.mapPageState.ajax;
    }

    @action.bound mapIsOk(data) {
        this.mapPageState.mapOk = true;
    }
    @action.bound changeAjaxState(flag = true) {
        this.mapPageState.ajax = flag;
    }
    @action.bound setMyLoc(data) {
        this.myLoc = data;
    }
    @action.bound mapPanToMyLoc() {
        // 移动到我的位置
        myMap.map.panTo(this.myLoc.bLoc);
    }
    @action.bound changeHideMarkerText(flag = true) {
        this.mapPageState.hideMarkerText = flag;
    }

    @action.bound toggleInfoBox(options) {
        let on_off = false;
        if (options) {
            on_off = options.on_off;
        } else {
            on_off = !this.win.infoBox._isOpen;
        }
        if (on_off) {
            let v = options.detail.v;
            // let i = options.detail.i;
            this.openInfoBox(v);
            $$("#marker_center").hide();
        } else {
            // 关闭 infobox
            // console.log('options.source', options.source)
            this.win.infoBox.close();
            $$("#marker_center").show();
        }
    }

    @action.bound openInfoBox(v) {
        // 去掉上一次点击请求成功的 橙色背景 当前 label 着色
        document.querySelectorAll("#map .marker_icon .top.__sele__").forEach((elm) => {
            elm.classList.remove('__sele__');
            elm.classList.add('{{selected}}');
        });
        const seleHtml = v.label.getContent().replace('{{selected}}', '__sele__');
        v.label.setContent(seleHtml);
        // 先打开才会有 infobox Dom
        this.win.infoBox.open(v.bLoc);


        // 打开后删除顶部为了 pin 撑开的 padding 空间 防止marker上方的地图点击无效
        // 每次 infoBox 被关闭 Dom会被删除 所以没关系
        document.querySelector(".infoBoxWrap").style.paddingTop = 0;
        this.win.infoBox.openMarkerId = v.id;
        $$("#infoBox_name")[0].innerText = v.name;
        // 打开啊 infobox 后判断是否覆盖 棒棒糖，如果覆盖则隐藏
        // 先显示，避免之前隐藏后 连续打开 infobox
        $$("#infoBox").removeClass("loading");
        $$("#marker_center").show();
        if (this.win.infoBox._isOpen && checkElmCover("#infoBox", "#marker_center")) {
            $$("#marker_center").hide();
        }

        // 清空 infoBox 里面的数据 如果未关闭上一个的直接打开新的，会使用上一次打开的infoBox Dom
        infoBoxHtmlHandle("delete");
        const thisTime = Date.now() - myConst.updateTimeout;
        // 超过时间则更新 否则使用本地数据
        if (v.lastUpdate && thisTime > v.lastUpdate && v.type === DATA_TYPE_STREET) {
            // ajax 修改数据
            getItem(this, v);
        } else {
            // 本地数据只更新 infoBox
            infoBoxHtmlHandle('modify', v);
        }
        infoBoxCoverHandle(this, v);
    }
}

function getItem(mapState, v) {
    $$("#infoBox").addClass("loading");
    getStreetDetail({
        id: v.id,
    }).then((d) => {
        const res = d.data.result;
        if (d.data.code !== 200) throw new Error(`请求数据错误 x502 ${d.data.msg}`);
        Object.assign(v, res);
        const html = makeMarkerHtml(v, 'getItem');
        v.label.setContent(html);
        // 如果现在打开的 infobox 还是 ajax 请求的 marker 则赋值
        if (mapState.win.infoBox.openMarkerId == v.id) {
            infoBoxHtmlHandle('modify', v);
        }
    }).catch((err) => {
        if (mapState.win.infoBox.openMarkerId == v.id) {
            infoBoxHtmlHandle('fail', v);
        }
        console.red('ajax Item Detail | net err', err);
        window.mdui.snackbar({
            message: `${err.message}`,
        });
    }).finally(() => {
        $$("#infoBox").removeClass("loading");
    });
}


/**
 * @name: checkElmCover
 * @description: 检查两个元素是否重叠
 * @param {type}
 * @return:
 */
function checkElmCover(elm1, elm2) {
    let objOne = $$(elm1),
        objTwo = $$(elm2);
    let one = objOne.offset();
    let two = objTwo.offset();
    let oC = {
        x: one.left + one.width / 2,
        y: one.top + one.height / 2,
    };
    let tC = {
        x: two.left + two.width / 2,
        y: two.top + two.height / 2,
    };
    return Math.abs(oC.x - tC.x) <= one.width / 2 + two.width / 2 && Math.abs(oC.y - tC.y) <= one.height / 2 + two.height / 2;
}

function infoBoxHtmlHandle(type, vv) {
    if (type === 'delete') {
        document.querySelector("#infoBox_total").textContent = "";
        document.querySelector("#infoBox_empty").textContent = "";
        document.querySelector("#infoBox_tel").innerHTML = "";
        document.querySelector("#infoBox_info").innerHTML = "";
    }
    if (type === 'modify' || type === 'fail') {
        const dataType = vv.type;
        const telHtml = `<a href="tel:{{tel}}">{{tel}}</a>`;
        // 两者区别主要是在时效性的东西上 如果错误 就删掉一些时效性的东西
        if (type === 'modify') {
            document.querySelector("#infoBox_empty").textContent = vv.eCount;
            document.querySelector("#infoBox_use").textContent = vv.uCount;
            document.querySelector("#infoBox_total").textContent = vv.cCount;
        }
        if (type === 'fail') {
            document.querySelector("#infoBox_empty").textContent = " ×";
            document.querySelector("#infoBox_use").textContent = " ×";
            document.querySelector("#infoBox_total").textContent = " ×";
        }

        // 常量两者都要赋值
        document.querySelector("#infoBox_tel").innerHTML = telHtml.replace(/{{tel}}/g, vv.tel);
        try {
            const tmplt = myConst.infoInfoHtml;
            // const tmplt = myConst[dataType];
            const info = vv.info;
            let infoHtml = "";
            if (dataType === DATA_TYPE_STREET) {
                info.rules.forEach((rule) => {
                    infoHtml += tmplt.replace("{{title}}", rule.title).replace("{{content}}", rule.content);
                });
            }
            if (dataType === DATA_TYPE_PARKING) {
                infoHtml = tmplt.replace("{{content}}", info.payRule);
            }
            if (dataType === DATA_TYPE_OIL || dataType === DATA_TYPE_NEWENERGY || dataType === DATA_TYPE_WC) {
                infoHtml = tmplt.replace("{{title}}", info.opentime).replace("{{content}}", info.introduce);
            }

            document.querySelector("#infoBox_info").innerHTML = infoHtml;
        } catch (error) {
            console.log('error', error);
            document.querySelector("#infoBox_info").innerHTML = "";
        }
    }
}
















function infoBoxCoverHandle(mapState, v) {
    if (!v.cover) {
        infoBoxCoverUsePano(mapState, v);
    } else {
        infoBoxCoverUseCover(v);
    }
}

function infoBoxCoverUseCover(v) {
    $$("#infoBox_a").attr("href", v.cover);
    $$("#infoBox_img").attr("src", v.cover);
}


function infoBoxCoverUsePano(mapState, v) {
    // 全景数据 点击图片后跳到全景
    $$("#infoBox_a").attr("href", `http://api.map.baidu.com/pano/?x=${v.lng}&y=${v.lat}&lc=0&ak=hItgwGlESMW1GTg8I0i9HewqGbGvCQNn`);
    if (!v.pano) {
        v.pano = new BMap.PanoramaService();
    }
    // 全景图片
    // 插入loading
    $$("#infoBox_img").attr("src", "./static/img/pano_loading.gif");
    if (!v.panoId) {
        // 根据单车点经纬度查找全景坐标 异步
        v.pano.getPanoramaByLocation(v.bLoc, 50, (data) => {
            if (data) {
                const panoId = data.id;
                v.panoId = panoId;
                // 异步拿到图片后需要判断是否还是当前打开的 openMaer
                if (mapState.win.infoBox.openMarkerId == v.id) {
                    let imgUlr = `https://mapsv0.bdimg.com/?qt=pdata&sid=${panoId}&pos=1_2&z=4`;
                    // const imgUlr = `http://pcsv1.map.bdimg.com/?qt=pdata&sid=${panoId}&pos=0_0&z=2`;
                    $$("#infoBox_img").attr("src", imgUlr);
                }
            } else {
                v.panoId = 'not';
            }
        });
    } else if (v.panoId && v.panoId != 'not') {
        let imgUlr = `https://mapsv0.bdimg.com/?qt=pdata&sid=${v.panoId}&pos=1_2&z=4`;
        $$("#infoBox_img").attr("src", imgUlr);
    } else {
        // 没有全景的地方
        // 恢复默认地图
        $$("#infoBox_img").attr("src", "./static/img/pano_default.png");
        $$("#infoBox_a").attr("href", "javascript:;");
    }
}